import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65b34080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }

import { storeToRefs } from 'pinia';
import { useHome, useShare } from '@/store';
import Swiper from '@/components/base/Swiper.vue';
import BannerBtn from './BannerBtn.vue';
import { useMedia } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  setup(__props) {

const { topCarouselInfo, entryVidId } = storeToRefs(useHome());

const { updateIsShareVisible } = useShare();

const { player } = storeToRefs(useMedia());
const {
  updateIsEnlarged,
  updateYoutube,
  updateYoutubeCover,
  updatePlayerState,
} = useMedia();
const playVideo = () => {
  updateIsEnlarged(true);
  updateYoutubeCover(
    `https://img.youtube.com/vi/${entryVidId.value}/maxresdefault.jpg`,
  );
  try {
    player.value.playVideo();
  } catch (err) {
    updatePlayerState('cued');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Swiper, {
      list: _unref(topCarouselInfo),
      type: 'banner',
      grabCursor: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true
    }, {
      play: _withCtx(() => [
        _createVNode(BannerBtn, {
          class: "play",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(updateYoutube)(_unref(entryVidId)))),
          onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_unref(updateYoutube)(_unref(entryVidId)))),
          onClick: playVideo
        })
      ]),
      _: 1
    }, 8, ["list", "pagination"]),
    _createVNode(BannerBtn, {
      class: "share",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(updateIsShareVisible)(true)))
    })
  ]))
}
}

})